import { SideMenuDrawer, SideMenuGroupHeader, ListMenuItem } from 'components/styles_components/menu';
import { Divider, List, ListItemText } from 'components/ui';
import {
  ProbelistUsersIcon,
  ProbelistDashboardIcon,
  ProbelistInspectionsIcon,
  ProbelistItemsIcon,
  ProbelistObjectsIcon,
  ProbelistProfileIcon,
  ProbelistSettingsIcon,
  ProbelistTemplatesIcon,
  ProbelistPaymentIcon,
  CalendarMonthIcon,
  DoDisturbIcon
} from 'components/uiIcons';
import { useMenu } from 'contexts/menu';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DashboardLink,
  InspectionsLink,
  InspectionsCalendarLink,
  InspectionSubjectsLink,
  PlacesLink,
  ProfileLink,
  SpaceShowLink,
  TemplatesLink,
  SpaceUsersLink,
  SpaceBillingLink,
} from 'utils/link';
import LogoutButton from 'components/layout/logout_button';
import SpaceSelector from 'components/layout/space_selector';
import useMobile from 'hooks/use_mobile';
import useUserHeader from 'hooks/use_user_header';

const SideMenu = () => {
  const location = useLocation();
  const isMobile = useMobile();
  const navigate = useNavigate();
  const { sidebarVisible, setSidebarVisible } = useMenu();
  const { user, space } = useUserHeader();
  const fullWidth = isMobile && sidebarVisible;

  const onItemClick = (link) => {
    if (isMobile) setSidebarVisible(false);
    navigate(link);
  };

  const isSelected = (link) =>
    location.pathname === link || location.pathname.startsWith(`${link}/`);

  const menuItem = (link, translationId, icon, selected = isSelected(link), enabled = space) => (
    <ListMenuItem key={link} onClick={() => onItemClick(link)} selected={selected} disabled={!enabled}>
      <span className="pre" />
      {icon}
      <ListItemText>
        <FormattedMessage id={translationId} />
      </ListItemText>
      {!enabled && <DoDisturbIcon />}
    </ListMenuItem>
  );

  return (
    <SideMenuDrawer
      id="side-menu"
      variant="persistent"
      className={fullWidth ? 'full-width' : ''}
      open={sidebarVisible}
    >
      {isMobile && space && <SpaceSelector currentName={space.name} />}
      {isMobile && space && <Divider />}

      <List component="nav" aria-label="Main navigation" sx={{ pb: isMobile ? 8 : 0 }}>
        <SideMenuGroupHeader>
          <FormattedMessage id="navbar.group.daily_work" />
        </SideMenuGroupHeader>
        {menuItem(DashboardLink(), 'navbar.home', <ProbelistDashboardIcon aria-hidden="true" />, false, true)}
        {menuItem(
          InspectionsLink(),
          'navbar.inspections',
          <ProbelistInspectionsIcon aria-hidden="true" />,
          isSelected(InspectionsLink()) && !isSelected(InspectionsCalendarLink()),
        )}
        {menuItem(InspectionsCalendarLink(), 'navbar.inspections.calendar', <CalendarMonthIcon aria-hidden="true" />)}
        <SideMenuGroupHeader>
          <FormattedMessage id="navbar.group.configuration" />
        </SideMenuGroupHeader>
        {menuItem(PlacesLink(), 'navbar.places', <ProbelistObjectsIcon aria-hidden="true" />)}
        {menuItem(InspectionSubjectsLink(), 'navbar.inspection_subjects', <ProbelistItemsIcon aria-hidden="true" />)}
        {user.adminRole && menuItem(TemplatesLink(), 'navbar.templates', <ProbelistTemplatesIcon aria-hidden="true" />)}

        {user.adminRole && (
          <>
            <SideMenuGroupHeader>
              <FormattedMessage id="navbar.group.space" />
            </SideMenuGroupHeader>
            {menuItem(SpaceShowLink(), 'navbar.space', <ProbelistSettingsIcon aria-hidden="true" />)}
            {menuItem(SpaceUsersLink(), 'navbar.users', <ProbelistUsersIcon aria-hidden="true" />)}
            {menuItem(SpaceBillingLink(), 'navbar.space.billing', <ProbelistPaymentIcon aria-hidden="true" />)}
          </>
        )}

        {isMobile && (
          <>
            <SideMenuGroupHeader>
              <FormattedMessage id="navbar.group.account" />
            </SideMenuGroupHeader>
            {menuItem(ProfileLink(), 'navbar.profile', <ProbelistProfileIcon aria-hidden="true" />, false, true)}
            <LogoutButton />
          </>
        )}
      </List>
    </SideMenuDrawer>
  );
};

export default SideMenu;
